import { render, staticRenderFns } from "./user-imags.vue?vue&type=template&id=c04f1314&scoped=true&"
import script from "./user-imags.vue?vue&type=script&lang=js&"
export * from "./user-imags.vue?vue&type=script&lang=js&"
import style0 from "./user-imags.vue?vue&type=style&index=0&id=c04f1314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04f1314",
  null
  
)

export default component.exports